export enum ScheduleType {
  RENEWAL = 'RENEWAL',
  RENEWAL_REMINDER = 'RENEWAL_REMINDER',
}
